<template>
  <div class="ranking-page">
    <div class="ranking-table">
      <div class="ranking-head">
        <div
          class="td"
          style="padding-left: 6px; width: 64px; box-sizing: border-box"
        >
          名次
        </div>
        <div></div>
        <div class="td" style="margin-left: -18px">航班号</div>
        <div></div>
        <div class="td" style="width: 64px">颠簸占比</div>
      </div>
      <div class="ranking-tr" v-for="(item, index) in bumpList">
        <div class="ranking-td active" style="width: 64px">
          NO.{{ index + 1 }}
        </div>
        <div class="ranking-td">/</div>
        <div class="ranking-td">{{item.fltNum}}</div>
        <div class="ranking-td">/</div>
        <div class="ranking-td" style="width: 64px">{{item.percentage}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import { listOfPercentage } from "@/api/bump";
export default {
  name: "ranking",
  data() {
    return {
      chart: null,
      bumpList:[]
    };
  },
  mounted() {
    //获取近几日颠簸占比
    this.listOfPercentage();
  },
  methods: {
    async listOfPercentage() {
      const param={}
      param.row=7
       const result = await listOfPercentage(param);
      //  console.log(result,'占比百分比')
       if(result.code === "A00000"){
        if (result.data.length > 0){
          this.bumpList=result.data
        }
       }
    },
  },
};
</script>

<style lang="less" scoped>
.ranking-page {
  margin-top: 30px;
  .ranking-table {
    text-align: left;
    .ranking-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(194, 217, 245, 0.65);
      font-size: 12px;
      height: 34px;
    }
    .ranking-tr {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #c2d9f5;
      font-size: 14px;
      height: 30px;
      .active {
        background: linear-gradient(
          90deg,
          #293752 0%,
          rgba(41, 55, 82, 0) 100%
        );
        height: 17px;
        display: flex;
        align-items: center;
        padding-left: 6px;
        color: rgba(194, 217, 245, 0.65);
        box-sizing: border-box;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/largescreen/components/ranking.vue